module.exports = __webpack_public_path__ + "img/Illustration-05.6ef986f2.png";